import React, { forwardRef, useId } from 'react';
import styled from 'styled-components';
import 'polished';
import '@s-group/design-system-tokens/web/tokens/size.es6.js';
import { useCombinedRef } from '../common/hooks.js';
import { TabStyle } from './Tabs.styles.js';
import { useTabList } from './hooks.js';

const TabPanel = forwardRef(({ children, id: propId, ...rest }, forwardedRef) => {
    const id = propId !== null && propId !== void 0 ? propId : useId();
    const ref = useCombinedRef(forwardedRef);
    const tabsContext = useTabList({ ...rest, id }, ref);
    const { icon, label, labelProps, selected, ...panelProps } = rest;
    const hidden = (tabsContext === null || tabsContext === void 0 ? void 0 : tabsContext.selected) === ref ? undefined : true;
    return (React.createElement("div", { ...panelProps, "aria-labelledby": `${id}tablabel`, hidden: hidden, id: id, role: "tabpanel", ref: ref }, children));
});
TabPanel.displayName = 'TabPanel';
/**
 * `<Tab>` is the container for a single tab panel used within `<Tabs>`.
 *
 * @public
 */
const Tab = styled(TabPanel) `
    ${TabStyle}
`;

export { Tab };
//# sourceMappingURL=Tab.js.map
